import React from 'react';

import {Button, A, Img} from 'views/AppElements';
import HeaderContainer from 'containers/HeaderContainer';
import Footer from 'views/Footer';
import {Helmet} from "react-helmet";

import AppConstants from 'AppConstants';
import 'css/ad.css';


const LeafBanner = ({text, id}) => {
    return <div className="flexRow leafBanner" id={id || ""}>
            <Img src="/images/banners/hga-campaign/banner-leaf.png"/>
            <span>{text}</span>
            <Img src="/images/banners/hga-campaign/banner-leaf.png" className="invertedLeaf" />
        </div>
}


const HGADesignCampaign = (props) => {
    const tshirtProduct = AppConstants.PRODUCT_TYPES['T_SHIRT'];
    return <div id="hgaCampaign">
        <Helmet>
            <title>High Ground Adventure Design Contest | Seto Canvas</title>
            <meta name="description" content="Design a T-Shirt for High Ground Adventure and Get a Chance to Win a Bunjee Jump." />
        </Helmet>
        <HeaderContainer />

        <div id="hgaCampaignHeader" className="flexRow">
            <div id="hgaCampaignInfo" className="flexColumn">
                <p>#adventureoncanvas</p>
                <h1>DESIGN A T-SHIRT</h1>
                <h4>FOR HIGH GROUND ADVENTURES</h4>
                <h4>AND GET A CHANCE TO</h4>
                <h2>WIN A BUNJEE JUMP</h2>

                <Button href="/design/submit" mui='true' color='primary' id="uploadHGADesignBtn">
                    Upload your Design
                </Button>
            </div>
            <div id="hgaTshirt">
                <Img src="/images/banners/hga-campaign/HGA Tshirt.png" alt="High Ground Adventure T-Shirt at setocanvas.com" />
            </div>
        </div>
        

        <div className="mainContainer flexRow" id="hgaContestRequirements">
            
            <div className="flexColumn eachColumn borderColumn">
                <LeafBanner id="designRequirement" text="Requirement for the Design"/>
                <div style={{textAlign: 'center'}}>
                    <Img src="/images/banners/hga-campaign/star.png" />
                </div>

                <span style={{margin: '10px 0', color: '#6d6a6a'}}><i>Must have one of the following text in your design</i></span>

                <div className="hgaTag" id="hgaTag1">
                    <h1>DREAM IT</h1>
                    <h1>DARE IT</h1>
                    <h1>DO IT</h1>
                </div>

                <div className="hgaTag">
                    <h1>WHERE</h1>
                    <h1>NATURE MEETS</h1>
                    <h1>ADVENTURE</h1>
                </div>
            </div>

            <div className="flexColumn eachColumn borderColumn" id="hgaTnC">
                <LeafBanner id="designTermsNCon" text="Terms & Conditions"/>

                <span>It's summertime, T-shirt time! Design a T-shirt for High Ground Adventure Nepal and Get a chance to win a Bungee Jump worth. </span>
                <span>It's time to stop dreaming about adventure and it's time to take leap of faith!</span>
                <span>Get into nature while doing something you always wanted to do.</span>
                <span>Winning design will be picked by the Seto Canvas Team and High Ground Adventure Nepal Team and will be announced in our Social Media Page.</span>

                <div className="flexColumn" id="downloadMedias">
                    <span>DOWNNLOAD NOW</span>
                    <div className="flexRow" id="downloadLinks">
                        <A href={tshirtProduct.psdTemplateUrl}>MOCKUP</A>
                        <A href="https://drive.google.com/drive/folders/1Y0DFKr35eSaxXeHiY64TMVFuQrdBwoMk?usp=sharing">LOGOS</A>
                        <A href="https://drive.google.com/drive/folders/1yoaFD9tdkRVcbfCsG_1iqfP-tSl07O__?usp=sharing">PHOTOS</A>
                    </div>
                </div>
            </div>

            <div className="flexColumn eachColumn">
                <LeafBanner text="Theme for Tee design"/>

                <div style={{textAlign: 'center'}}>
                    <Img src="/images/banners/hga-campaign/star.png" />
                </div>

                <div id="hgaTheme">
                    <h1>BUNGEE</h1>

                    <h1>ATV RIDE</h1>

                    <h1>ZIP LINE</h1>

                    <h1>SWING</h1>
                </div>
            </div>
        </div>

        <Footer />
        
    </div>
};


export default HGADesignCampaign;




// WEBPACK FOOTER //
// ./src/pages/campaigns/HGADesignCampaign.js